import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD57jvpx8QTkkN_O2-eUZu8Cs1pYIvmojk",
  authDomain: "grow-aa16a.firebaseapp.com",
  projectId: "grow-aa16a",
  storageBucket: "grow-aa16a.firebasestorage.app",
  messagingSenderId: "669494941386",
  appId: "1:669494941386:web:0eb6daf2ff610a62518633"
};

const app = initializeApp(firebaseConfig);

// Persistent local cache: writes are queued in IndexedDB first and synced
// to Firestore even if the tab is closed mid-write.
// persistentMultipleTabManager allows the app to work across multiple tabs.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const auth = getAuth(app);
